import Icon from 'assets/Icons';
import Text from 'components/Text';
import userSelectors from 'features/user/services/selectors';
// import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
type Props = {
  type?: 'ticket' | 'waiting';
  active?: boolean;
  onToggle: () => void;
  onDelete?: () => void;
  countSelected?: number;
};
const ButtonRemoveTicket = ({ type, active, onToggle, onDelete, countSelected }: Props) => {
  // const versionUI = shopSelectors.data.versionUI();
  const enableMergeTicket = userSelectors.enableMergeTicket();
  // if (versionUI === 'V2') return <div style={{ height: '2.5rem' }}></div>;
  if (enableMergeTicket && type === 'ticket') return null;
  return (
    <Wrapper>
      {active ? (
        <Row>
          <ButtonCancel onClick={onToggle}>
            <Text variant='H9'>Cancel</Text>
          </ButtonCancel>
          <ButtonSelected onClick={onDelete} className={countSelected === 0 ? 'disabled' : ''}>
            <Icon type='trashV2' fill='#FFFFFF' />
            <Text variant='H9' color='v2_neutral_1'>
              OK ({countSelected})
            </Text>
          </ButtonSelected>
        </Row>
      ) : <>  </>}
    </Wrapper>
  );
};

export default ButtonRemoveTicket;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .CONTENT_2 {
    font-size: 14px;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
`;

const ButtonSelected = styled.div`
  display: flex;
  height: 48px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: #f5767f;
  box-shadow:
    0 2px 4px 0 rgba(44, 35, 66, 0.4),
    0 4px 8px -3px rgba(45, 35, 66, 0.3),
    0 -3px 0 0 #e7646d inset;
  color: #ffffff;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
    pointer-events: none;
  }
`;

const ButtonCancel = styled.div`
  display: flex;
  height: 48px;
  padding: 16px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #e5e6eb;

  box-shadow:
    0 2px 4px 0 rgba(44, 35, 66, 0.4),
    0 4px 8px -3px rgba(45, 35, 66, 0.3),
    0 -3px 0 0 #d6d6e7 inset;

  cursor: pointer;
`;
